<template>
    <v-chip-group>
        <template v-for="(item, index) in items">
            <v-chip v-bind="item" disabled :key="index"> {{ item.text }} </v-chip>
        </template>
    </v-chip-group>
</template>

<script>
import { initLecture } from "@/store/lecture";

export default {
    props: {
        value: { type: Object, default: initLecture },
    },
    computed: {
        items() {
            let items = [];

            if (this.value.isStream) {
                items.push({
                    text: "실시간",
                    color: "white",
                    small: true,
                    class: "item-badge--is-stream",
                });
            }

            return items;
        },
    },
};
</script>

<style lang="scss" scoped>
.item-badge {
    &--is-stream {
        border: 1px solid red !important;
        color: red;
    }
}
</style>